export const ru = {
    from: 'от',
    per_night: 'за ночь',
    office: 'Офис',
};
